var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotationMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 29,
  viewBox: "0 0 34 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00B5AD",
  fillRule: "evenodd",
  d: "M34 5.438q-3.579.362-5.19 2.598-1.61 2.236-1.61 7.19h6.68V29H19.447V17.762q0-9.062 3.4-13.412Q26.244 0 34 0zm-19.446 0q-3.578.362-5.19 2.598-1.61 2.236-1.61 7.19h6.681V29H0V17.762Q0 8.7 3.4 4.35T14.554 0z"
})));
export default SvgQuotationMark;